import { FRONTEND_TOOL_CODES, FRONTEND_TOOL_NAMES } from "./frontendToolNames";
import { constStringNode, isRefusal, refuse, requiredString, type FrontendTool } from "./frontendTool";

/** Offers a dictionary record for review. Neither selection nor case values change. */
export const recommendWhoDrugTool: FrontendTool = {
  name: FRONTEND_TOOL_NAMES.recommendWhoDrug,
  declaration: (_location, screen) => {
    const review = screen?.whoDrug;
    if (!review) return null;
    return { name: FRONTEND_TOOL_NAMES.recommendWhoDrug,
      description: "Offer a WHODrug entry retrieved by search_whodrug. Loads the shared recode preview unless the reviewer changed their selection during the request. Never saves changes.",
      parameters: { type: "object", properties: {
        caseId: constStringNode(String(review.caseId)), productId: constStringNode(review.productId),
        releaseId: constStringNode(String(review.releaseId)), rid: { type: "string", description: "RID from the selected release's dictionary search." },
        rationale: { type: "string", description: "Explain supporting facts, conflicts and missing information." },
      }, required: ["caseId", "productId", "releaseId", "rid", "rationale"] } };
  },
  execute: async (args, env) => {
    const values: Record<string, string> = {};
    for (const key of ["caseId", "productId", "releaseId", "rid", "rationale"]) {
      const value = requiredString(args, key);
      if (isRefusal(value)) return value;
      values[key] = value as string;
    }
    const review = env.caseReview?.whoDrug;
    if (!review || String(review.caseId) !== values.caseId || review.productId !== values.productId
      || String(review.releaseId) !== values.releaseId) {
      return refuse(FRONTEND_TOOL_CODES.outOfScope, "The product or release under review has changed. Ask the reviewer to request a new recommendation.");
    }
    const accepted = await review.offer({ caseId: review.caseId, productId: review.productId,
      releaseId: review.releaseId, rid: values.rid, rationale: values.rationale });
    return accepted ? { ok: true, rid: values.rid, instruction: "The entry is ready in the recode comparison, or under View suggestion if the reviewer changed their selection. Tell them to inspect the comparison, then Apply to product or Discard selection. Nothing has been saved." }
      : refuse(FRONTEND_TOOL_CODES.outOfScope, "The review workspace changed while the entry was retrieved.");
  },
};
